module.exports = {}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle/nil.js
// module id = 465
// module chunks = 0